import React from 'react';
import clsx from 'clsx';

import {TooltipReact} from 'common/components/tooltip';
import {DropMenuReact} from 'common/components/drop-menu';
import {Directions} from 'common/components/drop-menu/types';
import {useTranslation} from 'common/i18n/hooks';

import {EventType} from '../types';
import styles from './index.module.styl';

export type EventIndicatorProps = {
  played?: boolean;
  isObserved?: boolean;
  tooltipText: string;
  isHovered?: boolean;
  groupCount?: number;
  eventType?: EventType;
};

export function EventIndicator(props: EventIndicatorProps) {
  const {t} = useTranslation();

  const isRageClick = props.eventType === EventType.RageClick;
  const isDeadClick = props.eventType === EventType.DeadClick;

  return (
    <div
      className={clsx(styles.eventIndicator, {
        [styles.played]: props.played,
        [styles.observed]: props.isObserved,
        [styles.isHovered]: props.isHovered,
        [styles.rageClick]: isRageClick,
        [styles.deadClick]: isDeadClick,
      })}
    >
      {isRageClick && <div className={styles.rageClickIcon} />}
      {isDeadClick && <div className={styles.deadClickIcon} />}
      {props.isHovered === undefined ? (
        <TooltipReact>{props.tooltipText}</TooltipReact>
      ) : (
        <DropMenuReact open={props.isHovered} offset={0} direction={Directions.UpCenter}>
          <div className={styles.interactionContext}>
            <div>
              {props.groupCount && props.groupCount > 1
                ? t(`session-replay.event-group-label`, {name: props.tooltipText, count: props.groupCount - 1})
                : props.tooltipText}
            </div>
          </div>
        </DropMenuReact>
      )}
    </div>
  );
}
